import { never, withQueryParams, type QueryParams } from "utils"

export const redirectTo = async (url: string, params: QueryParams) => {
  const href = withQueryParams(url, params)
  window.location.href = href
  return never()
}
